export const CHANGE_TYPE_OPTIONS = [
  {
    label: '全部',
    value: 0,
  },
  {
    label: '签约代理佣金',
    value: 1, //实际字典值1-100
  },
  {
    label: '周奖励',
    value: 101,
  },
  {
    label: '月奖励',
    value: 102,
  },
  {
    label: 'VIP奖励',
    value: 103,
  },
  {
    label: '手动上下分',
    value: 104,
  },
  {
    label: '提款退款/冲正',
    value: 106,
  },
  {
    label: '代理佣金',
    value: 107,
  },
  {
    label: '注册奖励',
    value: 108,
  },
  {
    label: '存款',
    value: 888,
  },
  {
    label: '存款赠送',
    value: 889,
  },
  {
    label: '提款',
    value: 666,
  },
  {
    label: '第三方游戏下注',
    value: 10001,
  },
  {
    label: '第三方游戏赢钱',
    value: 10002,
  },
  {
    label: '第三方游戏回滚',
    value: 10003,
  },
  {
    label: '幸运转盘',
    value: 10004,
  },
  {
    label: '金币雨奖励',
    value: 10005,
  },
  {
    label: '签到',
    value: 10006,
  },
  {
    label: '存款赠送活动',
    value: 10007,
  },
]

export const WITHDRAW_STATUS_OPTIONS = [
  {
    label: '全部',
    value: 0,
    type: '',
  },
  {
    label: '待处理',
    value: 1,
    type: '',
  },
  {
    label: '处理中',
    value: 2,
    type: '',
  },
  {
    label: '核实中',
    value: 3,
    type: '',
  },
  {
    label: '提款中',
    value: 4,
    type: '',
  },
  {
    label: '成功',
    value: 7,
    type: 'success',
  },
  {
    label: '失败',
    value: 6,
    type: 'danger',
  },
  {
    label: '已拒绝',
    value: 5,
    type: 'warning',
  },

  {
    label: '已退款',
    value: 8,
    type: 'danger',
  },
  {
    label: '第三方支付错误',
    value: 9,
    type: 'danger',
  },
]
